import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=82453d1e&"
import script from "./PageIndex.vue?vue&type=script&lang=js&"
export * from "./PageIndex.vue?vue&type=script&lang=js&"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=82453d1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports